// extracted by mini-css-extract-plugin
export default {"imageBack":"styles_imageBack__W0ocV","imageBackMobile":"styles_imageBackMobile__jwziW","zeroPadding":"styles_zeroPadding__ZiPKK","buttonSend":"styles_buttonSend__EqhCY"};